import { styled } from '@mui/material/styles';
var NewCard = styled('div')(function (_a) {
    var theme = _a.theme, width = _a.width;
    return ({
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        width: width || '100%',
        height: 'auto',
        boxSizing: 'border-box',
        padding: theme.spacing(4),
        gap: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        border: "1px solid ".concat(theme.palette.divider),
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.text.primary,
    });
});
export default NewCard;
